import axios from "axios";
import { Component } from "react";
import { setHeaderAuth } from "../utils";

export default class ApiUser extends Component {
  static login = async (data) => {
    const result = await axios({
      url: "user/login",
      method: "post",
      data: data,
    });
    return result;
  };
  static loginV2 = async (data) => {
    const result = await axios({
      url: "user/loginV2",
      method: "post",
      data: data,
    });
    return result;
  };
  static submitToken = async (data) => {
    const result = await axios({
      url: "user/submitToken",
      method: "post",
      data: data,
    });
    return result;
  };
  static submitTokenV2 = async (data) => {
    const result = await axios({
      url: "user/submitTokenV2",
      method: "post",
      data: data,
    });
    return result;
  };
  static submitChangePassword = async (data) => {
    const result = await axios({
      url: "user/submitChangePassword",
      method: "post",
      data: data,
    });
    return result;
  };
  static submitChangeToken = async (data) => {
    const result = await axios({
      url: "user/submitChangeToken",
      method: "post",
      data: data,
    });
    return result;
  };
  static userAgency = async (agency_id) => {
    await setHeaderAuth();
    const result = await axios({
      url: `user/useragency/${agency_id}`,
      method: "get",
    });
    return result;
  };
  static userCentral = async () => {
    await setHeaderAuth();
    const result = await axios({
      url: `user/usercentral`,
      method: "get",
    });
    return result;
  };
  static userAgencyById = async () => {
    await setHeaderAuth();
    const result = await axios({
      url: "user/agency",
      method: "get",
    });
    return result;
  };
  static createAgency = async (data) => {
    await setHeaderAuth();
    const result = await axios({
      url: "user/register",
      method: data.id ? "put" : "post",
      data: data,
    });
    return result;
  };
  static createUser = async (data) => {
    await setHeaderAuth();
    const result = await axios({
      url: "user/createuser",
      method: "post",
      data: data,
    });
    return result;
  };
  static registerToken = async (data) => {
    const result = await axios({
      url: "user/registerToken",
      method: "put",
      data: data,
    });
    return result;
  };

  static editStatus = async (id, record_status) => {
    const result = await axios({
      url: `user/editStatus/${id}`,
      method: "put",
      data: { record_status: record_status },
    });
    return result;
  };
  static logout = async () => {
    await setHeaderAuth();
    const result = await axios({
      url: "user/logout",
      method: "get",
    });
    return result;
  };
}
